// src/components/ads-admin/FullscreenOverlay.jsx
import React from "react";

export default function FullscreenOverlay({ open, title, onClose, children }) {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        background: "#0b1220",
        zIndex: 90,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: 14,
          background: "#0f172a",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ fontWeight: 900 }}>{title}</div>
        <button className="btn-secondary" onClick={onClose} style={{ padding: "8px 12px", borderRadius: 12 }}>
          Exit full screen
        </button>
      </div>
      <div style={{ padding: 14, overflow: "auto", flex: 1, background: "#f8fafc" }}>{children}</div>
    </div>
  );
}